import accordion from "../accordion";

export default function HeatByHeatSessionResults(){
  if( ! $('#hbh-session-results').length ) { return; }
  
  const eventUrl = window.location.pathname.split('/')
  const eventSanction = eventUrl[2]
  const eventSession = eventUrl[4]
  const eventSessionName = eventUrl[6].replace(/-/g, ' ');
  const heading = $('#sr-session-name')
  const mobileContainer = $('#sr-mobile')
  const desktopContainer = $('#sr-desktop')
  const loaded = (target) => $(target).addClass('loaded')
  const error = () => console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
  const renderHeading = () => heading.html(eventSessionName)

  function accordion() {
    $('.smx-acc .smx-acc-item .smx-acc-trigger').click(function(){
      $(this).parent().find('.smx-acc-content').slideToggle()
      $(this).find('i').toggleClass('active')
    })
  }
  
  function renderResults(data) {
    let mobileContent = ''
    let desktopContent = ''

    for(let result of data){
      const pos = result.Position
      const number = result.Comp
      const name = result.FullName
      const sponsors = result.Sponsors
      const bike = result.Bike
      const interval = result.Interval
      const gap = result.Gap
      const bestLap = result.BestTimeText
      const points = result.Points

      mobileContent += `<div class="smx-acc-item">`
      mobileContent += `  <div class="smx-acc-trigger">`
      mobileContent += `    <div class="smx-acc-col">${pos}</div>`
      mobileContent += `    <div class="smx-acc-col">${number}</div>`
      mobileContent += `    <div class="smx-acc-col">${name}</div>`
      mobileContent += `    <div class="smx-acc-col">${sponsors}</div>`
      mobileContent += `    <i class="fas fa-caret-down"></i>`
      mobileContent += `  </div>`
      mobileContent += `  <div class="smx-acc-content">`
      mobileContent += `    <div class="wrapper">`
      mobileContent += `      <div class="smx-acc-row">`
      mobileContent += `        <div class="label">Bike</div>`
      mobileContent += `        <div class="value">${bike}</div>`
      mobileContent += `      </div>`
      mobileContent += `      <div class="smx-acc-row">`
      mobileContent += `        <div class="label">Interval</div>`
      mobileContent += `        <div class="value">${interval}</div>`
      mobileContent += `      </div>`
      mobileContent += `      <div class="smx-acc-row">`
      mobileContent += `        <div class="label">Gap</div>`
      mobileContent += `        <div class="value">${gap}</div>`
      mobileContent += `      </div>`
      mobileContent += `      <div class="smx-acc-row">`
      mobileContent += `        <div class="label">Best lap</div>`
      mobileContent += `        <div class="value">${bestLap}</div>`
      mobileContent += `      </div>`
      mobileContent += `      <div class="smx-acc-row">`
      mobileContent += `        <div class="label">Points</div>`
      mobileContent += `        <div class="value">${points}</div>`
      mobileContent += `      </div>`
      mobileContent += `    </div>`
      mobileContent += `  </div>`
      mobileContent += `</div>`

      desktopContent += `<div class="smx-table-body-row">`
      desktopContent += `  <div class="smx-table-body-col">${pos}</div>`
      desktopContent += `  <div class="smx-table-body-col">${number}</div>`
      desktopContent += `  <div class="smx-table-body-col">${name}</div>`
      desktopContent += `  <div class="smx-table-body-col">${sponsors}</div>`
      desktopContent += `  <div class="smx-table-body-col">${bike}</div>`
      desktopContent += `  <div class="smx-table-body-col">${interval}</div>`
      desktopContent += `  <div class="smx-table-body-col">${gap}</div>`
      desktopContent += `  <div class="smx-table-body-col">${bestLap}</div>`
      desktopContent += `  <div class="smx-table-body-col">${points}</div>`
      desktopContent += `</div>`
    }

    mobileContainer.html(mobileContent)
    desktopContainer.html(desktopContent)
  }
  
  
  $.ajax( {
    url: `https://data-aws.amaproracing.com/api/results/${eventSession}`,
    method: 'GET',
    dataType: 'json',
    error: () => error(),
    success: data => {

      renderHeading()
      renderResults(data)
      accordion()
      loaded('#hbh-session-results')

    }
  });

}